import { render, staticRenderFns } from "./actExpration.vue?vue&type=template&id=0d3aa3a0&scoped=true"
import script from "./actExpration.vue?vue&type=script&lang=js"
export * from "./actExpration.vue?vue&type=script&lang=js"
import style0 from "./actExpration.vue?vue&type=style&index=0&id=0d3aa3a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3aa3a0",
  null
  
)

export default component.exports